import { useContext } from 'react';
import { ContentContext, IWithContent } from 'providers';

export default () => {
  const contentContext: IWithContent = useContext(ContentContext);
  return contentContext.content;
};
